<template>
  <b-row>
    <b-colxx class="disable-text-selection">
      <b-row>
        <b-colxx xxs="12">
          <h1><i class="iconsminds-stethoscope mr-2"></i>Les Operations</h1>

          <div class="mb-2 mt-2">
            <b-button
              variant="empty"
              class="pt-0 pl-0 d-inline-block d-md-none"
              v-b-toggle.displayOptions
            >
              {{ $t("pages.display-options") }}
              <i class="simple-icon-arrow-down align-middle" />
            </b-button>
          </div>
          <div class="separator mb-5" />
        </b-colxx>
      </b-row>
      <template v-if="isLoad">
        <b-form-group :label="'Filtrer par'">
          <b-form-radio-group>
            <b-form-radio v-model="filterBy" value="date">Date</b-form-radio>
            <b-form-radio v-model="filterBy" value="other" :state="true"
              >Autres</b-form-radio
            >
          </b-form-radio-group>
        </b-form-group>
        <label
          v-show="filterBy == 'other'"
          class="form-group has-float-label"
          v-if="listOperations.length"
        >
          <input
            placeholder="Filtrer par Nom ou le CIN du Patient ou le titre d'opération"
            type="text"
            class="form-control"
            v-model="searchText"
          />
          <span>Rechercher</span>
        </label>
        <b-form-group v-show="filterBy == 'date'">
          <datepicker
            class="form-control"
            v-model="dateFilter"
            placeholder="Date"
            :language="fr"
            :clear-button="true"
            clear-button-icon="iconsminds-close"
            @cleared="(dateFilter = null), (filterBy = '')"
          ></datepicker>
        </b-form-group>
        <b-row v-if="displayMode === 'thumb'" key="thumb">
          <b-colxx
            xxs="12"
            class="mb-3"
            v-for="(item, index) in filtredOperations"
            :key="index"
            :id="item.id"
          >
            <data-list-item
              :key="item.id"
              :data="item"
              @edit="editOperation($event, item.id)"
              @delete="deleteOperation($event, item.id)"
            />
          </b-colxx>
          <b-colxx xxs="12" class="mb-3" v-if="operationPage">
            <b-button
              v-if="!loadingMore"
              @click="getMoreOperations()"
              type="button"
              variant="primary"
              size="lg"
              class="w-100"
              :disabled="false"
              >Charger Plus</b-button
            >
            <b-button v-else disabled variant="primary" size="lg" class="w-100">
              <div class="span w-100">
                <div class="typing_loader"></div>
              </div>
            </b-button>
          </b-colxx>
        </b-row>
        <b-card class="w-100" v-if="!filtredOperations.length" no-body>
          <b-card-body class="text-center p-4">
            <h5 class="card-title mb-0">Aucune opération trouvé.</h5>
          </b-card-body>
        </b-card>
      </template>
      <template v-else>
        <div class="loading"></div>
      </template>
    </b-colxx>
  </b-row>
</template>
<script>
import "vue-select/dist/vue-select.css";
import Vue from "vue";
import { fr } from "vuejs-datepicker/dist/locale";
import "bootstrap";
import bootbox from "bootbox";
import DataListItem from "@/components/Listing/OperationListItem";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import { apiUrl } from "@/constants/config";
export default {
  components: {
    DataListItem,
    Datepicker,
  },
  data() {
    return {
      isLoad: false,
      apiBase: apiUrl,
      currentOperation: null,
      isEdit: false,
      displayMode: "thumb",
      listOperations: [],
      newUser: {
        name: "",
        cin: "",
        email: "",
        phone: "",
        mituel: "",
      },
      searchText: "",
      filterBy: "",
      dateFilter: new Date(),
      fr: fr,
      operationPage: null,
      loadingMore: false,
    };
  },
  methods: {
    getMoreOperations() {
      this.loadingMore = true;
      let page = this.operationPage;
      this.sendRequest("get", this.currentEndpoint + "/page/" + page)
        .then(async (res) => {
          this.listOperations = [...this.listOperations, ...res.data.data];
          this.operationPage = res.data.next;
          this.loadingMore = false;
        })
        .catch((err) => {
          this.loadingMore = false;
          console.log("iam the error", err);
        });
    },
    getOperations() {
      this.isLoad = false;
      let page = this.operationPage ? this.operationPage : 1;
      this.sendRequest("get", this.currentEndpoint + "/page/" + page)
        .then(async (res) => {
          console.log("reees", res);
          this.listOperations = res.data.data;
          this.operationPage = res.data.next;
          this.isLoad = true;
        })
        .catch((err) => {
          this.isLoad = true;
          console.log("iam the error", err);
        });
    },
    editOperation(event, id) {
      let index = this.listOperations.findIndex((obj) => obj.id == id);
      let item = this.listOperations[index];
      this.currentOperation = item;
      this.isEdit = event;
      this.newUser.name = item.name;
      this.newUser.cin = item.cin;
      this.newUser.email = item.email;
      this.newUser.phone = item.phone;
      this.newUser.mituel = item.mituel;
      // this.$refs.modalright.show()
    },
    deleteOperation(event, id) {
      let index = this.listOperations.findIndex((obj) => obj.id == id);
      let item = this.listOperations[index];
      bootbox.confirm({
        message: "Etes vous Sur ?",
        locale: "fr",
        callback: (result) => {
          if (result) {
            this.deleteCurrentOperation(item.id, index);
          }
        },
      });
    },
    deleteCurrentOperation(id, index) {
      this.sendRequest("delete", this.currentEndpoint + `/id/${id}`)
        .then((res) => {
          if (res.status == 200) {
            this.listOperations.splice(index);
          }
        })
        .catch((err) => {
          this.isLoad = true;
        });
    },
  },
  computed: {
    currentEndpoint() {
      return `${this.apiBase}/operations`;
    },
    filtredOperations() {
      if (this.filterBy == "") {
        return this.listOperations;
      } else if (this.filterBy == "date") {
        if (this.dateFilter) {
          return this.listOperations.filter((res) => {
            let have = false;
            let date = moment(this.dateFilter);
            for (let i = 0; i < res.rdvs.length; i++) {
              let currentDate = moment(res.rdvs[i].date);
              let dt = currentDate.diff(date, "days");
              if (dt == 0) {
                have = true;
              }
            }
            return have;
          });
        } else {
          return this.listOperations;
        }
      } else {
        return this.listOperations.filter((res) => {
          return (
            res.description
              .toLowerCase()
              .includes(this.searchText.toLowerCase()) ||
            res.patient.name
              .toLowerCase()
              .includes(this.searchText.toLowerCase()) ||
            res.patient.cin
              .toLowerCase()
              .includes(this.searchText.toLowerCase())
          );
        });
      }
    },
  },
  watch: {
    currentEndpoint() {
      this.getOperations();
    },
  },
  mounted() {
    this.getOperations();
  },
};
</script>
<style lang="scss">
.bootbox {
  .modal-dialog {
    .modal-content {
      .modal-footer {
        padding: 15px;
      }
    }
  }
}
.vdp-datepicker {
  input {
    border: 0;
    width: calc(100% - 25px);
  }
}

.typing_loader {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  -webkit-animation: typing 1s linear infinite alternate;
  -moz-animation: Typing 1s linear infinite alternate;
  animation: typing 1s linear infinite alternate;
  margin: 10px auto; /* Not necessary- its only for layouting*/
  position: relative;
  left: -12px;
}
@-webkit-keyframes typing {
  0% {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 0.2),
      24px 0px 0px 0px rgba(255, 255, 255, 0.2);
  }
  25% {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 2),
      24px 0px 0px 0px rgba(255, 255, 255, 0.2);
  }
  75% {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 0.2),
      24px 0px 0px 0px rgba(255, 255, 255, 1);
  }
}

@-moz-keyframes typing {
  0% {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 0.2),
      24px 0px 0px 0px rgba(255, 255, 255, 0.2);
  }
  25% {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 2),
      24px 0px 0px 0px rgba(255, 255, 255, 0.2);
  }
  75% {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 0.2),
      24px 0px 0px 0px rgba(255, 255, 255, 1);
  }
}

@keyframes typing {
  0% {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 0.2),
      24px 0px 0px 0px rgba(255, 255, 255, 0.2);
  }
  25% {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 2),
      24px 0px 0px 0px rgba(255, 255, 255, 0.2);
  }
  75% {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 0.2),
      24px 0px 0px 0px rgba(255, 255, 255, 1);
  }
}
</style>

